import React, { useEffect, useState, useMemo } from "react";
import  HeaderTable from "../DataTable/HeaderTable";
import  PaginationComponent from "../DataTable/Pagination";
import SearchTable from "../DataTable/Search";
import "./style.css";
import { changeIndexToNepali, colorScale } from "../../utils";


export default function SummaryTable({comments, title, categories}) {
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [refresh, setRrefresh] = useState(false);
    const [sorting, setSorting] = useState({ field: "", order: "" });
    const ITEMS_PER_PAGE = 10;

    const headers = [
        { name: "क्र.स.", field: "id", sortable: false },
        { name: "बिषय क्षेत्र", field: "name", sortable: false },
        { name: "जम्मा", field: "score", sortable: false },
        { name: "प्रकिया सूचक(औसत)", field: "name", sortable: false },
        { name: "नतिजा सूचक(औसत)", field: "name", sortable: false },
        { name: "वित्तीय अनुशासनका सूचक(औसत)", field: "name", sortable: false },
        { name: "कुल प्राप्तांक(औसत)", field: "name", sortable: false },
    ];
    const commentsData = useMemo(() => {
        let computedComments = comments;

        if (search) {
            computedComments = computedComments.filter(
                comment =>
                    comment.name.toLowerCase().includes(search.toLowerCase()) 
                    // ||
                    // comment.img.toLowerCase().includes(search.toLowerCase())
            );
        }

        setTotalItems(computedComments.length);

        //Sorting comments
        if (sorting.field) {
            const reversed = sorting.order === "asc" ? 1 : -1;
            computedComments = computedComments.sort(
                (a, b) =>
                    reversed * a[sorting.field].localeCompare(b[sorting.field])
            );
        }

        //Current Page slice
        return computedComments.slice(
            (currentPage - 1) * ITEMS_PER_PAGE,
            (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
        );
    }, [comments, currentPage, search, sorting]);

    return (
        <div className="card-layout">
            <div className="row">
                <div className="col mb-3 col-12 text-center">
                    <div className="row table-heading">
                        <div className="col-md-6">
                            <h1 className="sub-heading">{title}</h1>
                        </div>
                    </div>
                    {commentsData == ''? <h4>विवरण उपलब्ध छैन</h4> : 
                    <table className="table table-responsive table-bordered">
                        <HeaderTable
                            type = 'nested'
                            headers={headers}
                            onSorting={(field, order) =>
                                setSorting({ field, order })
                            }
                        />
                        <tbody>
                            {commentsData.map((comment, i) => (
                                <tr>
                                    <th scope="row" key={comment.id}>
                                        {changeIndexToNepali(++i)}
                                    </th>
                                    {comment.map(item=>
                                        <td style={{minWidth: 180}}>{changeIndexToNepali(item)}</td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>}
                </div>
            </div>
            
        </div>
    )
}
